/**
 * 旧PCRM のボタンの形と色（262 r1）。旧 frontend/src/index.css の .btn と色の決まり：
 * - .btn：高さ 32px・上下 6px・左右 12px・角 6px・13px・太さ 500・行高 1（MUI の最小幅 64px は持たない）
 * - .btn-primary：#EA580C（hover #C2410C）／.btn-danger：#DC2626（hover #B91C1C）／.btn-success：#10B981（hover #059669）
 * - 青（取込のテンプレート）：#2563EB（hover #1D4ED8）
 * - 白の枠線（キャンセル・詳細・ファイルを選択・すべて表示）：旧のスクショの実色＝白地・#DDD の枠・#333 の文字（hover #F1F5F9）
 * - .btn-outline（全選択・全解除）・.btn-ghost（← 戻る）
 * テーマ（全画面のボタンをオレンジにする 257 の決まり）は変えず、旧に合わせる画面のボタンにだけ sx で当てる。
 * 使い方：<Button variant="contained" sx={{ ...LEGACY_BUTTON_SX, ...LEGACY_BUTTON_COLORS.danger }}>削除</Button>
 */
export const LEGACY_BUTTON_SX = {
  minWidth: 0,
  height: 32,
  minHeight: 32,
  px: '12px',
  py: '6px',
  borderRadius: '6px',
  fontSize: 13,
  fontWeight: 500,
  lineHeight: 1,
  whiteSpace: 'nowrap',
} as const;

function filled(main: string, hover: string) {
  return {
    bgcolor: main,
    color: '#FFFFFF',
    border: 'none',
    '&:hover': { bgcolor: hover },
  } as const;
}

export const LEGACY_BUTTON_COLORS = {
  primary: filled('#EA580C', '#C2410C'),
  danger: filled('#DC2626', '#B91C1C'),
  success: filled('#10B981', '#059669'),
  info: filled('#2563EB', '#1D4ED8'),
  /** 旧のスクショの実色（白地・#DDD の枠・#333 の文字）。キャンセル・詳細・ファイルを選択・すべて表示 */
  white: {
    bgcolor: '#FFFFFF',
    color: '#333333',
    border: '1px solid #DDDDDD',
    '&:hover': { bgcolor: '#F1F5F9', borderColor: '#CBD5E1' },
  },
  /** 旧 .btn-outline（全選択・全解除）：枠 #CBD5E1・文字 #475569、hover でオレンジ */
  outline: {
    bgcolor: 'transparent',
    color: '#475569',
    border: '1px solid #CBD5E1',
    '&:hover': { bgcolor: '#E2E8F0', borderColor: '#EA580C', color: '#EA580C' },
  },
  /** 旧 .btn-ghost（「← 戻る」）：枠なし・14px・左右 12px・灰色の文字 */
  ghost: {
    bgcolor: 'transparent',
    color: '#475569',
    border: 'none',
    fontSize: 14,
    '&:hover': { bgcolor: '#E2E8F0', color: '#1E293B' },
  },
} as const;

/** よく使う組み合わせ */
export const LEGACY_PRIMARY_BUTTON_SX = { ...LEGACY_BUTTON_SX, ...LEGACY_BUTTON_COLORS.primary } as const;
export const LEGACY_DANGER_BUTTON_SX = { ...LEGACY_BUTTON_SX, ...LEGACY_BUTTON_COLORS.danger } as const;
export const LEGACY_WHITE_BUTTON_SX = { ...LEGACY_BUTTON_SX, ...LEGACY_BUTTON_COLORS.white } as const;
